import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  NavLink,
  useLocation,
} from "react-router-dom";
import "./research.css";
import "./editorial.css";
import Home from "@/pages/Home";
import { House } from "lucide-react";
import Account, { SessionProvider } from "@/components/Account";
import SavedReports from "@/components/SavedReports";
import Research from "@/pages/Research";
import Independence from "@/pages/Independence";
import Unavailable from "@/pages/Unavailable";
import Suburbs from "@/pages/Suburbs";
import Privacy from "@/pages/Privacy";
import Onboarding from "@/pages/Onboarding";
import OwnershipScenario from "@/pages/OwnershipScenario";
import AskPropAI from "@/pages/AskPropAI";
function ResearchRoute() {
  const { pathname, search } = useLocation();
  return <Research key={pathname + search} />;
}
export default function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <a className="skip-link" href="#main">
          Skip to content
        </a>
        <header className="site-header">
          <Link className="brand" to="/">
            <House size={32} strokeWidth={1.4} aria-hidden="true" />{" "}
            <span className="brand-name">Prop AI</span>
          </Link>
          <nav aria-label="Main navigation">
            <NavLink to="/ask">Ask Prop AI</NavLink>
            <NavLink to="/research">Research</NavLink>
            <NavLink to="/suburbs">Suburb guides</NavLink>
            <NavLink to="/saved">Saved & compare</NavLink>
            <NavLink to="/account">Account</NavLink>
          </nav>
        </header>
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/research" element={<ResearchRoute />} />
            <Route path="/ask" element={<AskPropAI />} />
            <Route path="/account" element={<Account />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/ownership" element={<OwnershipScenario />} />
            <Route path="/saved" element={<SavedReports />} />
            <Route path="/suburbs" element={<Suburbs />} />
            <Route path="/suburbs/:slug" element={<Suburbs />} />
            <Route path="/independence" element={<Independence />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<Unavailable />} />
          </Routes>
        </main>
        <footer>
          <Link to="/privacy">Privacy & data</Link> ·{" "}
          <Link to="/independence">Our independence</Link> · Prop AI · General
          information only. Verify property-specific findings with the relevant
          authority and qualified professionals.
        </footer>
      </SessionProvider>
    </BrowserRouter>
  );
}
